const config = {
  cognito: {
    REGION: "us-east-1",
    USER_POOL_ID: "us-east-1_traolCwX8",
    APP_CLIENT_ID: "5rkn9p3n98q7cdfbb1ir7pfm1p",
  },
  baseApiURL:
    "https://46mamrcro0.execute-api.us-east-1.amazonaws.com/development",
  webSocketURL:
    "wss://cc2xltt0u6.execute-api.us-east-1.amazonaws.com/development",
};
export default config;
